import { avatarUri } from '../lib/avatar.js';

/**
 * `online` is deliberately three-valued. true and false draw the dot; leaving
 * it undefined draws nothing, because a surface that has no idea whether
 * someone is connected should not claim they are away.
 */
export default function Avatar({ person, size = '', title, online }) {
  const image = (
    <img
      className={`avatar ${size}`.trim()}
      src={avatarUri(person)}
      alt={person.displayName || 'visitor'}
      title={title ?? person.displayName}
      draggable={false}
    />
  );

  if (online === undefined || online === null) return image;

  return (
    <span
      className={`avatar-wrap ${size}`.trim()}
      title={title ?? `${person.displayName}${online ? ' · here now' : ' · away'}`}
    >
      {image}
      <span className={`presence-dot ${online ? 'on' : ''}`} aria-hidden="true" />
    </span>
  );
}
